<template>
  <fragment>
    <v-expansion-panel v-for="(opcion, index) in opciones" :key="index">
      <v-expansion-panel-header v-if="opcion.opciones" @click="opcion.objetos && handleClick(opcion)" :class="'btn-nivel-' + nivel">
        {{ opcion.etiqueta }}
        <v-icon v-if="opcion.objetos">mdi-map-marker-multiple</v-icon>
      </v-expansion-panel-header>

      <v-expansion-panel-content v-if="opcion.opciones">
        <v-expansion-panels v-if="nivel < 2" class="d-block">
            <OpcionRecursiva :opciones="opcion.opciones" @trigger-accion="handleClick" :nivel="nivel+1" />
        </v-expansion-panels>
        <OpcionRecursiva v-else :opciones="opcion.opciones" @trigger-accion="handleClick" :nivel="nivel+1" />
      </v-expansion-panel-content>
      
      <v-btn v-if="opcion.objetos && !opcion.opciones" block text outlined max-width="100" class="v-btn-tiene-objetos" :class="'btn-nivel-' + nivel"
        @click="handleClick(opcion)">
        {{ opcion.etiqueta }}
        <v-icon>mdi-map-marker-multiple</v-icon>
      </v-btn>
    </v-expansion-panel>
  </fragment>
</template>

<script>
export default {
  name: "OpcionRecursiva",
  props: {
    opciones: {
      type: Array,
      required: true,
    },
    nivel: {
      type: Number,
      default: 1,
    }
  },
  methods: {
    handleClick(opcion) {
      this.$emit("trigger-accion", opcion);
    }
  },
};
</script>

<style scoped>
.v-btn-tiene-objetos {
  text-transform: none;
}

.v-btn.btn-nivel-1, .v-expansion-panel-header.btn-nivel-1 {
  min-height: 56px;
  height: 56px;
}

.v-btn.btn-nivel-2, .v-expansion-panel-header.btn-nivel-2 {
  min-height: 42px;
  height: 42px;
}

.v-btn.btn-nivel-3, .v-expansion-panel-header.btn-nivel-3 {
  margin-top: 8px;
  min-height: 36px;
  height: 36px;
}

</style>